import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, ActionSheetController, NavController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio';
import { AppVersion } from '@ionic-native/app-version';
import { InAppBrowser } from '@ionic-native/in-app-browser';


import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { UtiltiyProvider } from '../providers/utiltiy/utiltiy';
import { PrestartPage } from '../pages/prestart/prestart';
import { CabsandPrestartPage } from '../pages/cabsand-prestart/cabsand-prestart';
import { KlmrFuelPage } from '../pages/klmr-fuel/klmr-fuel';
import { KlmrFuelTruckPage } from '../pages/klmr-fuel-truck/klmr-fuel-truck';
import { CabsandFuelPage } from '../pages/cabsand-fuel/cabsand-fuel';
import { CabsandFuelTruckPage } from '../pages/cabsand-fuel-truck/cabsand-fuel-truck';
import { KlmrJsaAddPage } from '../pages/klmr-jsa-add/klmr-jsa-add';
import { KlmrJsaPage } from '../pages/klmr-jsa/klmr-jsa';
import { CabsandJsaPage } from '../pages/cabsand-jsa/cabsand-jsa';
import { KlmrTimesheetCreatePage } from '../pages/klmr-timesheet-create/klmr-timesheet-create';
import { CabsandTimesheetCreatePage } from '../pages/cabsand-timesheet-create/cabsand-timesheet-create';
import { KlmrNewsPage } from '../pages/klmr-news/klmr-news';
import { CabsandNewsPage } from '../pages/cabsand-news/cabsand-news';
import { KlmrTimesheetPendingPage } from '../pages/klmr-timesheet-pending/klmr-timesheet-pending';
import { KlmrTimesheetApprovalsPage } from '../pages/klmr-timesheet-approvals/klmr-timesheet-approvals';
import { KlmrTimesheetHistoryPage } from '../pages/klmr-timesheet-history/klmr-timesheet-history';
import { CabsandTimesheetPendingPage } from '../pages/cabsand-timesheet-pending/cabsand-timesheet-pending';
import { CabsandTimesheetHistoryPage } from '../pages/cabsand-timesheet-history/cabsand-timesheet-history';
import { CabsandTimesheetApprovalsPage } from '../pages/cabsand-timesheet-approvals/cabsand-timesheet-approvals';
import { KlmrJobcardPage } from '../pages/klmr-jobcard/klmr-jobcard';
import { CabsandJobcardPage } from '../pages/cabsand-jobcard/cabsand-jobcard';

import { CrudProvider } from '../providers/crud/crud';

import { ENV } from '../env/environment';
import { KlmrFleetinfoPage } from '../pages/klmr-fleetinfo/klmr-fleetinfo';
import { CabsandFleetinfoPage } from '../pages/cabsand-fleetinfo/cabsand-fleetinfo';

import { KlmrDashboardPage } from '../pages/klmr-dashboard/klmr-dashboard';
import { CabsandDashboardPage } from '../pages/cabsand-dashboard/cabsand-dashboard';
import { SafariViewController } from '@ionic-native/safari-view-controller';
import { KlmrTake_5Page } from '../pages/klmr-take-5/klmr-take-5';
import { KlmrTakeTemplatePage } from '../pages/klmr-take-template/klmr-take-template';
import { CabsandTake_5Page } from '../pages/cabsand-take-5/cabsand-take-5';
import { CabsandTakeTemplatePage } from '../pages/cabsand-take-template/cabsand-take-template';
import { KlmrTakeTemplateAddPage } from '../pages/klmr-take-template-add/klmr-take-template-add';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;

  
  // pages: Array<{ title: string, component: any }>;
  pages: any = [];
  showLevel1 = null;
  showLevel2 = null;
  sideMenu: any = [];
  currentGroup: any = null;
  biometricAvailable: boolean = false;
  biometricCounter: any = 0;
  currentPermission:any = null;
  appCurrentVersion:any = null;
  applatestversion:any = null;
  constructor(private safariViewController: SafariViewController,public platform: Platform, public actionSheetCtrl: ActionSheetController, public faio: FingerprintAIO, public statusBar: StatusBar, public events: Events, public splashScreen: SplashScreen, private utility: UtiltiyProvider,public api:CrudProvider,public appVersion:AppVersion,private iab: InAppBrowser) {
    this.initializeApp();
    events.subscribe('chnageSideMenu', (role) => {
      this.roleBasedSideMenu(role);
    });

    events.subscribe('currentClass', (selectedGroup) => {
      this.changeGroup(selectedGroup);

    });
    events.subscribe('currentPermission', (selectedPeermission) => {
     this.currentPermission = selectedPeermission;

    });
    events.subscribe('appVersion', (currentAppVersion) => {
     this.appCurrentVersion = currentAppVersion;

    });
    events.subscribe('currentVersion', (latestAppVersion) => {
      if(latestAppVersion){
        this.verifyAppVersion();
      }
    //  this.appCurrentVersion = currentAppVersion;

    });




    // used for an example of ngFor and navigation
    this.sideMenu = [
      {
        "category": "Klmr",
        "colorCode": "#b71464",
        "subs": [
          {
            "title": "Prestart",
            "component": PrestartPage,
          },
          {
            "title": "Fuel",
            "component": KlmrFuelPage,
          },
          {
            "title": "Fuel Truck",
            "component": KlmrFuelTruckPage,
          },
        ]
      },
      {
        "category": "Cabsand",
        "colorCode": "#b1651c",
        "subs": [
          {
            "title": "Prestart",
            "component": CabsandPrestartPage,
          },
        ]
      },
    ]



  }


  async openMenu() {
    let biometricStatus = await this.utility.getStorage("biometric");

    let actionSheet = this.actionSheetCtrl.create({
      title: 'Biometric',
      cssClass: 'action-sheets-basic-page',
      buttons: [
        biometricStatus ? {
          text: 'Deactivate',
          role: 'destructive',
          handler: () => {
            this.activateDeactivateBioMetric(false);
          }
        } :
          {
            text: 'Activate',
            handler: () => {
              this.activateDeactivateBioMetric(true);
            }
          },
      ]
    });
    actionSheet.present();
  }

  activateDeactivateBioMetric(status) {
    this.utility.toaster(status ? "Activated" : "Deactivated");
    this.utility.setStorage("biometric", status);
  }

  async getappColor() {
    // this.appColor = await this.utility.getStorage("primaryColor");
  }


  logout() {
    this.utility.removeStorage("token");
    this.utility.removeStorage("roleID");
    this.utility.removeStorage("primaryColor");
    this.utility.removeStorage("name");
    this.utility.removeStorage("permissions");
    this.utility.removeStorage("biometric");
    this.nav.setRoot(HomePage);
  }

  toggleLevel1(idx) {
    if (this.isLevel1Shown(idx)) {
      this.showLevel1 = null;
    } else {
      this.showLevel1 = idx;
    }
  };

  toggleLevel2(idx) {
    if (this.isLevel2Shown(idx)) {
      this.showLevel1 = null;
      this.showLevel2 = null;
    } else {
      this.showLevel1 = idx;
      this.showLevel2 = idx;
    }
  };

  isLevel1Shown(idx) {
    return this.showLevel1 === idx;
  };

  isLevel2Shown(idx) {
    return this.showLevel2 === idx;
  };

  async getState() {
    console.log("i was called -4");
    let status = await this.utility.getStorage("token");
    let roleId = await this.utility.getStorage("roleID");
    let currentGroup = await this.utility.getStorage("currentClass");
    let biometricStatus = await this.utility.getStorage("biometric");


    if (status) {
      if (biometricStatus) {
        let verifiedUser = await this.verifyUser();
        console.log("verifiedUser", verifiedUser);
        if (!verifiedUser) {
          this.bioLogout();
          return;
        } else {
          this.utility.toaster("Welcome Back");
        }
      }
      // this.roleBasedSideMenu(roleId);
      // this.rootPage = HomePage;
      if (currentGroup == "klmr") {
        // this.rootPage = KlmrNewsPage;
        // this.rootPage = KlmrDashboardPage;
        this.rootPage = KlmrNewsPage;
      } else if (currentGroup == "cabsand") {
        // this.rootPage = CabsandDashboardPage;
        this.rootPage = CabsandNewsPage;
      }

    } else {
      this.rootPage = HomePage;
    }

    if (currentGroup) {
      this.changeGroup(currentGroup);

    } else {
      this.pages = [
        { title: 'Home', component: HomePage },
      ]
    }
    console.log("status", status)
  }


  async resumeBioMetric() {
    console.log("i was called-1");
    let biometricStatus = await this.utility.getStorage("biometric");
    if (biometricStatus) {
      this.faio.show({
        clientId: 'klmr-cabsand',
        clientSecret: 'klmrcabsand', //Only necessary for Android
        disableBackup: true, //Only for Android(optional)
        localizedFallbackTitle: 'Use Pin', //Only for iOS
        localizedReason: 'Please Authenticate' //Only for iOS
      })
        .then(async (status: any) => {
          console.log("status", status)
          this.utility.toaster("Welcome Back");
          this.biometricCounter++;
        })
        .catch((error: any) => {
          this.bioLogout();
          //Fingerprint/Face was not successfully verified
          //  this.utility.presentAlert(error);

        });
    }
  }

  bioLogout() {
    this.nav.setRoot(LoginPage);
    this.utility.toaster("Invalid User");
    this.utility.removeStorage("token");
    this.utility.removeStorage("roleID");
    this.utility.removeStorage("primaryColor");
    this.utility.removeStorage("name");
    this.utility.removeStorage("permissions");
    this.utility.removeStorage("biometric");
  }

  checkBioMetric() {

    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      // this.biometricAvailable = true;
      return;
    }

    this.faio.isAvailable()
      .then(async (result) => {
        console.log("result----", result)
        if (result === "biometric" || result === "face") {
          this.biometricAvailable = true;
        }
      });
  }

  checkAppVersion() {

    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      // this.biometricAvailable = true;
      return this.appCurrentVersion;
    }

    this.appVersion.getVersionNumber()
      .then(async (result) => {
        console.log("result----", result)
        this.appCurrentVersion = result;
        this.utility.setStorage("appVersion", result);
      });
  }

  async verifyUser() {
    console.log("platform is", this.platform);
    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      console.log("it is web");
      // this.biometricAvailable = true;
      return true;
    } else {
      console.log("it is app");

      //Check if Fingerprint or Face  is available
      return this.faio.isAvailable()
        .then(async (result) => {
          console.log("result", result)
          if (result === "biometric" || result === "face") {
            this.biometricAvailable = true;
            //Fingerprint or Face Auth is available
            return this.faio.show({
              clientId: 'klmr-cabsand',
              clientSecret: 'klmrcabsand', //Only necessary for Android
              disableBackup: true, //Only for Android(optional)
              localizedFallbackTitle: 'Use Pin', //Only for iOS
              localizedReason: 'Please Authenticate' //Only for iOS
            })
              .then(async (status: any) => {
                console.log("status", status)
                return true;
              })
              .catch((error: any) => {
                console.log("error is", error)
                //Fingerprint/Face was not successfully verified
                //  this.utility.presentAlert(error);
                return false;

              });
          }
          else {
            return true;

            //Fingerprint or Face Auth is not available
            //  this.utility.presentAlert("Fingerprint/Face Auth is not available   on this device!");
          }
        })
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if(ENV.PRODUCTION){
        console.log = function(){} ;
        
      }

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // this.statusBar.styleBlackTranslucent();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#000000');

      this.splashScreen.hide();
      this.getState();
      this.platform.pause.subscribe(async () => {
        this.biometricCounter = 0;
      });

      this.platform.resume.subscribe(async () => {
        if (this.biometricCounter == 0) {
          this.resumeBioMetric();
        }
        //Do stuff here
      });
      this.checkBioMetric();
      this.checkAppVersion();

    });
  }

  changeGroup(group) {
    this.currentGroup = group;
    if (group == "klmr") {
      let pageList = [
        {
          "category": "Home",
          "categoryDisplay": true,
          "isSingle":true,
          "subs": [
            {
              "title": "Home",
              "component": KlmrDashboardPage,
              "pageIdentity": "home",
              "display": true
            },
          ]
        },
        {
          "category": "News",
          "categoryDisplay": true,
          "isSingle":true,

          "subs": [
            {
              "title": "News",
              "component": KlmrNewsPage,
              "pageIdentity": "news",
              "display": true
            },
          ]
        },
        {
          "category": "Prestart",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["klmr-prestart-ro", "klmr-prestart-rw"],
          "subs": [
            {
              "title": "Prestart",
              "component": PrestartPage,
              "pageIdentity": ["klmr-prestart-ro", "klmr-prestart-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Jobcard",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["klmr-jobcard-ro", "klmr-jobcard-rw"],
          "subs": [
            {
              "title": "Jobcard",
              "component": KlmrJobcardPage,
              "pageIdentity": ["klmr-jobcard-ro", "klmr-jobcard-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Timesheets",
          "categoryDisplay": false,
          "isSingle":false,

          "categoryIds": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
          "subs": [
            {
              "title": "Create",
              "component": KlmrTimesheetCreatePage,
              "pageIdentity": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
              "display": false
            },
            // {
            //   "title": "Pending",
            //   "component": KlmrTimesheetPendingPage,
            //   "pageIdentity": "timesheet_ViewPendingRO"
            // },
            {
              "title": "History",
              "component": KlmrTimesheetHistoryPage,
              "pageIdentity": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
              "display": false
            },
            {
              "title": "Approvals",
              "component": KlmrTimesheetApprovalsPage,
              "pageIdentity": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Take-5",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["klmr-take-five-ro", "klmr-take-five-rw"],
          "subs": [
            // {
            //   "title": "Take-5",
            //   "component": KlmrTake_5Page,
            //   "pageIdentity": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
            //   "display": false
            // },
           
            {
              "title": "Template",
              "component": KlmrTakeTemplateAddPage,
              "pageIdentity": ["klmr-take-five-ro", "klmr-take-five-rw"],
              "display": false
            },
            
          ]
        },
        {
          "category": "Fleet Information",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["klmr-fleet-information-ro", "klmr-fleet-information-rw"],
          "subs": [
            {
              "title": "Fleet Information",
              "component": KlmrFleetinfoPage,
              "pageIdentity": ["klmr-fleet-information-ro", "klmr-fleet-information-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Fuel",
          "categoryDisplay": false,
          "categoryIds": ["klmr-fuel-truck-ro", "klmr-fuel-truck-rw", "klmr-fuel-ro", "klmr-fuel-rw"],
          "subs": [
            {
              "title": "Fuel Truck",
              "component": KlmrFuelTruckPage,
              "pageIdentity": ["klmr-fuel-truck-ro", "klmr-fuel-truck-rw"],
              "display": false
            },
            {
              "title": "Fuel",
              "component": KlmrFuelPage,
              "pageIdentity": ["klmr-fuel-ro", "klmr-fuel-rw"],
              "display": false

            },

          ]
        },
        {
          "category": "Forms",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["klmr-jsa-ro", "klmr-jsa-rw"],
          "subs": [
            {
              "title": "Jsa",
              "component": KlmrJsaPage,
              "pageIdentity": ["klmr-jsa-ro", "klmr-jsa-rw"],
              "display": false

            },

          ]
        },
      ]

      this.permissions(pageList);

    } else if (group == "cabsand") {
      let pageList = [
        {
          "category": "Home",
          "categoryDisplay": true,
          "isSingle":true,

          "subs": [
            {
              "title": "Home",
              "component": CabsandDashboardPage,
              "pageIdentity": "home",
              "display": true
            },
          ]
        },
        {
          "category": "News",
          "categoryDisplay": true,
          "isSingle":true,

          "subs": [
            {
              "title": "News",
              "component": CabsandNewsPage,
              "pageIdentity": "news",
              "display": true

            },
          ]
        },
        {
          "category": "Prestart",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["cabsand-prestart-ro", "cabsand-prestart-rw"],
          "subs": [
            {
              "title": "Prestart",
              "component": CabsandPrestartPage,
              "pageIdentity": ["cabsand-prestart-ro", "cabsand-prestart-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Jobcard",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["cabsand-jobcard-ro", "cabsand-jobcard-rw"],
          "subs": [
            {
              "title": "Jobcard",
              "component": CabsandJobcardPage,
              "pageIdentity": ["cabsand-jobcard-ro", "cabsand-jobcard-rw"],
              "display": false
            },
          ]
        },

        {
          "category": "Timesheets",
          "categoryDisplay": false,
          "isSingle":false,

          "categoryIds": ["cabsand-timesheet-create-ro", "cabsand-timesheet-create-rw"],
          "subs": [
            {
              "title": "Create",
              "component": CabsandTimesheetCreatePage,
              "pageIdentity": ["cabsand-timesheet-create-ro", "cabsand-timesheet-create-rw"],
              "display": false
            },
            // {
            //   "title": "Pending",
            //   "component": CabsandTimesheetPendingPage,
            //   "pageIdentity": "cabsand_timesheet_ViewPendingRO"
            // },
            {
              "title": "History",
              "component": CabsandTimesheetHistoryPage,
              "pageIdentity": ["cabsand-timesheet-create-ro", "cabsand-timesheet-create-rw"],
              "display": false
            },
            {
              "title": "Approvals",
              "component": CabsandTimesheetApprovalsPage,
              "pageIdentity": ["cabsand-timesheet-create-ro", "cabsand-timesheet-create-rw"],
              "display": false
            },
          ]
        },

        {
          "category": "Take-5",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["cabsand-take-five-ro", "cabsand-take-five-rw"],
          "subs": [
            // {
            //   "title": "Take-5",
            //   "component": CabsandTake_5Page,
            //   "pageIdentity": ["klmr-timesheet-create-ro", "klmr-timesheet-create-rw"],
            //   "display": false
            // },
           
            {
              "title": "Template",
              // "component": CabsandTakeTemplatePage,
              "component": KlmrTakeTemplateAddPage,
              "pageIdentity": ["cabsand-take-five-ro", "cabsand-take-five-rw"],
              "display": false
            },
            
          ]
        },
 

        {
          "category": "Fleet Information",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds": ["cabsand-fleet-information-ro", "cabsand-fleet-information-rw"],
          "subs": [
            {
              "title": "Fleet Information",
              "component": CabsandFleetinfoPage,
              "pageIdentity": ["cabsand-fleet-information-ro", "cabsand-fleet-information-rw"],
              "display": false
            },
          ]
        },
        {
          "category": "Fuel",
          "categoryDisplay": false,
          "isSingle":false,

          "categoryIds": ["cabsand-fuel-truck-ro", "cabsand-fuel-truck-rw","cabsand-fuel-ro", "cabsand-fuel-rw"],
          "subs": [
            {
              "title": "Fuel Truck",
              "component": CabsandFuelTruckPage,
              "pageIdentity": ["cabsand-fuel-truck-ro", "cabsand-fuel-truck-rw"],
              "display": false

            },
            {
              "title": "Fuel",
              "component": CabsandFuelPage,
              "pageIdentity": ["cabsand-fuel-ro", "cabsand-fuel-rw"],
              "display": false

            },
          ]
        },
        {
          "category": "Forms",
          "categoryDisplay": false,
          "isSingle":true,

          "categoryIds":  ["cabsand-jsa-ro", "cabsand-jsa-rw"],
          "subs": [
            {
              "title": "Jsa",
              "component": CabsandJsaPage,
              "pageIdentity": ["cabsand-jsa-ro", "cabsand-jsa-rw"],
              "display": false
            },

          ]
        },
      ]
      this.permissions(pageList);
    } else if (group == "home") {
      this.pages = [
        { title: 'Home', component: HomePage },
      ]
    }

  }

  conditionBasedMenu(menuData) {

  }

  roleBasedSideMenu(role) {
    if (role == "1") {

    } else {

    }

  }

  async permissions(currentPages) {
    let permissions = await this.utility.getStorage("permissions");

    if(!permissions){
      permissions = this.currentPermission != null?JSON.stringify(this.currentPermission):null;
    }

    if (permissions) {
      permissions = JSON.parse(permissions);
    }else{
      return;
    }

    console.log("permissions",permissions)
    currentPages.forEach(pages => {
      if (pages.category != "News" && pages.category != "Home") {

        pages.categoryIds.forEach(ids => {
          if (permissions.hasOwnProperty(ids)) {
            pages.categoryDisplay = true;
          }
        });
        pages.subs.forEach((subs_,i) => {
          subs_.pageIdentity.forEach(pageIdentity => {
            if (permissions.hasOwnProperty(pageIdentity)) {
              subs_.display = true;
            }
          });
         
        });
      }
    });
    console.log("currentPages", currentPages)
    this.pages = currentPages;
  }

  async getPermissiionList() {
    let currentGroup = await this.utility.getStorage("currentClass");
    this.api.get("/login/roles", false)
      .then((result: any) => {
        console.log("result", result)
        this.utility.setStorage("permissions", JSON.stringify(result.data.permissions_role));
        this.changeGroup(currentGroup);
      }, err => {
        
      })
  }


  async openPage(page) {
    this.getPermissiionList();
    
    if (this.platform.is('mobileweb') || this.platform.is('core')) {
      this.getLatesVersion();
    }else{
      this.getLatesVersion();
    }
    let status = false;
    let permissions = await this.utility.getStorage("permissions");
    if (permissions) {
      permissions = JSON.parse(permissions);
    }
    console.log("permissions are ", permissions)
    // this.utility.setStorage("primaryColor",parent.colorCode);
    // this.getappColor();
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //     this.nav.setRoot(page.component);
    // return;
    if (page.component == DashboardPage) {
      return;
    }
    if (page.component == CabsandNewsPage || page.component == KlmrNewsPage || page.component == KlmrDashboardPage || page.component == CabsandDashboardPage) {
      this.nav.setRoot(page.component);
     
      return;
    }

    page.pageIdentity.forEach(id_ => {
      if (permissions.hasOwnProperty(id_)) {
        status = true;
      }
      
    });

    if (status) {
      this.nav.setRoot(page.component);
    } else {
      this.utility.toaster("Access Restricted");
      // this.nav.setRoot(page.component);
    }
    
    if(!this.appCurrentVersion || !this.applatestversion){
      return;
    }
    let appCurrentVersion:number, applatestversion:number;
    [appCurrentVersion, applatestversion] = await this.versionToNumber(this.appCurrentVersion, this.applatestversion);
    if(appCurrentVersion < applatestversion){
      if (this.platform.is('mobileweb') || this.platform.is('core')) {
        this.verifyAppVersion();

      }else{
        this.verifyAppVersion();
      }
    }
  }
  async versionToNumber(...versions:String[])
  {
      let maxlen=1;
      let allvers=versions.join('.').split('.');
      for (let i = 0; i < allvers.length; i++)
      {
          let thisbit=allvers[i];
          if (thisbit.length > maxlen)
          {
              maxlen=thisbit.length;
          }
      }
      let pad="0".repeat(maxlen);
      let numbers:number[]=[];
      for (let i = 0; i < versions.length; i++)
      {
          let thisver=versions[i].split('.');
          let number=thisver[0];
          for (let j = 1; j < thisver.length; j++)
          {
              number+=(pad+thisver[j]).slice(0 - maxlen);
          }
          numbers.push(parseInt(number));
      }
      return numbers;
  }

  async verifyAppVersion(){
    var options = {
      "title": 'New Update Available',
      "message": '',
      "approveText": 'OK',
    };
    let status = await this.utility.appUpdateDialog(options);
    if (status) {
      if (this.platform.is('android')) {
        window.open("https://play.google.com/store/apps/details?id=io.ionic.klmr","_system");
      }else if(this.platform.is('ios')){
        // window.location.href = "https://hub.klmrcivil.com.au/mobile"
        // const browser =  this.iab.create("itms-services://?action=download-manifest&url=https://hub.klmrcivil.com.au/mobile/live/manifest.plist", "_blank", "location=yes,enableviewportscale=yes");
        // const browser =  this.iab.create("https://hub.klmrcivil.com.au/mobile", "_system");
        // browser.show();
        this.safariViewController.isAvailable()
  .then((available: boolean) => {
      if (available) {

        this.safariViewController.show({
          url: 'https://hub.klmrcivil.com.au/mobile',
          hidden: false,
          animated: false,
          transition: 'curl',
          enterReaderModeIfAvailable: true,
          tintColor: '#ff0000'
        })
        .subscribe((result: any) => {
            if(result.event === 'opened') console.log('Opened');
            else if(result.event === 'loaded') console.log('Loaded');
            else if(result.event === 'closed') console.log('Closed');
          },
          (error: any) => console.error(error)
        );

      } else {
        // use fallback browser, example InAppBrowser
      }
    }
  );
      }else{
        window.open("itms-services://?action=download-manifest&url=https://hub.klmrcivil.com.au/mobile/live/manifest.plist","_system");
      }
      console.log("status is",status)
    }
  }
  async getLatesVersion(){
    this.api.get("/App_Version/App_Version", "false")
    .then((result: any) => {
      if(result.status){
        this.applatestversion = result.result[0].app_version;

        // if (this.appCurrentVersion !=  this.applatestversion) {
        //   this.events.publish('currentVersion', true);
        // }
      }

      console.log("result ",result )
    }, err => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts